"use client";

import { Box, Link, Typography, styled } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { Tag } from "@/ui";
import isPlaceholderEmail from "@lib/candidates/isPlaceholderEmail";

const Wrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

const ContactList = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.75),
}));

const ChipRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

const ContactItem = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  color: theme.palette.text.secondary,
  fontSize: "0.875rem",
  "& svg": {
    fontSize: 18,
    color: theme.palette.text.secondary,
  },
  "& a": {
    color: theme.palette.text.secondary,
  },
}));

const formatDate = (value) => {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleDateString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export default function CandidateHeaderDetails({ candidate }) {
  const email = isPlaceholderEmail(candidate.email) ? "" : candidate.email;

  return (
    <Wrap>
      {candidate.position_title && (
        <Typography
          color="text.secondary"
          sx={{ font: "var(--text-h4)", mt: "-4px", mb: "12px" }}
        >
          {candidate.position_title}
        </Typography>
      )}

      <ContactList>
        {email && (
          <ContactItem>
            <EmailOutlinedIcon titleAccess="Email" />
            <Link href={`mailto:${email}`} underline="hover">
              {email}
            </Link>
          </ContactItem>
        )}
        {candidate.phone && (
          <ContactItem>
            <PhoneOutlinedIcon titleAccess="Phone" />
            <span>{candidate.phone}</span>
          </ContactItem>
        )}
        {candidate.address_address && (
          <ContactItem>
            <LocationOnOutlinedIcon titleAccess="Location" />
            <span>{candidate.address_address}</span>
          </ContactItem>
        )}
        {candidate.linkedin && (
          <ContactItem>
            <LinkedInIcon titleAccess="LinkedIn" />
            <Link
              href={candidate.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              LinkedIn
            </Link>
          </ContactItem>
        )}
      </ContactList>

      <ChipRow>
        {candidate.created_at && (
          <Tag color="info">{`Added ${formatDate(candidate.created_at)}`}</Tag>
        )}
        {candidate.updated_at && (
          <Tag color="success">{`Updated ${formatDate(candidate.updated_at)}`}</Tag>
        )}
      </ChipRow>
    </Wrap>
  );
}
